export const MIN_LATEST_TRIPS_DAYS = 30;
export const DEVICE_GPS_UPDATE_TIMER_MIN = 3;
export const TRIP_STATUS_UPDATE_TIMER_MIN = 3;
export const LIVE_VIEW_TAB = ['LIVE VIEW', 'FLEET VIEW'];
export const LIVE_FILTER_OPTION = [
  {
    id: 'assetId',
    label: 'Asset',
  },
  {
    id: 'tags',
    label: 'Tags',
  },
];

export const EVENT_LIST_TABLE_HEADER = ['eventName', 'actions'];
export const EVENT_LIST_PAGE_SIZE = 10;
export const INITIAL_LOADER_STATES: any = () => ({
  current: 0,
  initiated: false,
  connecting: {
    inProgress: true,
  },
  connected: {
    inProgress: false,
  },
  generating: {
    inProgress: false,
  },
});

export enum AssetLiveViewState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Parked = 'PARKED',
}

export enum CallState {
  CONSENT = 'consent',
  IDLE = 'call',
  DISABLED = 'disabled',
  CALLING = 'calling',
  ACTIVE = 'active',
  IGNORED = 'ignored',
}
export interface DeviceStatePayload {
  timestamp?: string;
  audioRecordingEnabled?: boolean;
  audioRecordingDisabledReason?: string;
}
export interface SessionSummary {
  requestId: string;
  ringStartTime: string;
  startTime: string;
  endTime: string;
  status: string;
  durationMs: number;
}
export const SOUNDS: Record<string, string> = {
  calling: 'assets/common/ringing.mp3',
  end: 'assets/common/call-ended.mp3',
  ignore: 'assets/common/ignore.mp3',
  error: 'assets/common/modal.mp3',
  modal: 'assets/common/modal.mp3',
  answered: 'assets/common/answered.mp3',
  spacebar: 'assets/common/spacebar.mp3',
};

export type UIEvent =
  | { type: 'callState'; state: 'accepted' | 'disconnected' | 'ignored' }
  | { type: 'micError'; hasError: boolean }
  | { type: 'network'; speed: any }
  | { type: 'summary'; summary: any }
  | { type: 'deviceAlert'; payload: DeviceAudioAlert };

export interface DeviceAudioAlert {
  requestId: string;
  eventType: string;
  timestamp: string;
}
export const EVENT_LABELS = {
  SPEED_UPPER_LIMIT_REACHED: 'Speed Limit Reached',
  SPEEDING_VIOLATION: 'Speeding',
  STOP_SIGN_VIOLATED: 'Stop Sign Violation',
  FORWARD_COLLISION_WARNING: 'Forward Collision Warning',
  TAILGATING_VIOLATED: 'Tailgating',
  LANE_DEPARTURE: 'Lane Departure',
  LANE_DRIFT: 'Lane Drift',
  TRAFFIC_LIGHT_VIOLATED: 'Traffic Light Violation',
  DRIVER_DISTRACTION_VIOLATION: 'Driver Distraction',
  DRIVER_CELLPHONE_DISTRACTION: 'Phone Distraction',
  DROWSY_DRIVING_VIOLATION: 'Drowsy Driving',
  UNBUCKLED_SEAT_BELT: 'Seat Belt Unbuckled',
  DRIVER_SMOKING_DISTRACTION: 'Smoking While Driving',
  DRIVER_DRINKING_DISTRACTION: 'Drinking While Driving',
  HARSH_ACCELERATION: 'Harsh Acceleration',
  HARSH_BRAKING: 'Harsh Braking',
  HARSH_CORNERING: 'Harsh Cornering',
  ROLL_OVER_DETECTED: 'Rollover Detected',
  DRIVER_FATIGUE: 'Driver Fatigue',
  ANOMALY: 'Anomaly Detected',
};
